import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HttpImageComponent } from '@jump-tech-frontend/image-analysis';

export type ExampleImage = { kind: 'image'; src: string } | { kind: 'icon'; name: string; size?: string };

@Component({
  selector: 'question-example-images',
  imports: [HttpImageComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @for (example of examples(); track $index) {
      <div class="question-example-image">
        @if (example.kind === 'icon') {
          <i [class]="'material-icons ' + (example.size ?? '')" [id]="key() + '_' + $index + '_temp'">{{
            example.name
          }}</i>
        } @else {
          <crds-http-image
            [src]="example.src"
            [alt]="key() + ' ' + ($index + 1)"
            [id]="key() + '_' + $index + '_temp'"
            [allowDownload]="false"
          ></crds-http-image>
        }
      </div>
    }
  `,
  styles: `
    :host {
      display: block;
    }

    .question-example-image {
      margin-top: var(--jds-space-sm);
    }
  `
})
export class QuestionExampleImagesComponent {
  public readonly examples = input.required<ExampleImage[]>();
  public readonly key = input.required<string>();
}
